import { styled, Snackbar, SnackbarProps, Alert } from '@mui/material'
import { KnownActions } from './KnownActions'
import { clearDialog, useDialog } from '../dialog.store'

const StyledSnackbar = styled(Snackbar)`
    white-space: pre-line;
`

const ButtonColor = styled('div')`
    color: red;
`

export const AppSnackbar: React.FC = () => {
    const { id, action, message, timeout, type, color } = useDialog() || {}

    const onClose: SnackbarProps['onClose'] = (_event, reason) => {
        if (reason === 'clickaway') {
            return
        }

        clearDialog()
    }

    if (type !== 'SNACKBAR' || !message) {
        return <div />
    }

    const severity = color ? color.toLowerCase() : undefined
    const ActionComponent = KnownActions[action || 'CLOSE']
    const snackBarAction = color ? undefined : (
        <ButtonColor>
            <ActionComponent />
        </ButtonColor>
    )

    return (
        <StyledSnackbar
            key={id}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            ContentProps={{ 'aria-describedby': 'notification-message' }}
            open
            autoHideDuration={timeout}
            message={message}
            onClose={onClose}
            action={snackBarAction}
        >
            {color ? (
                <Alert
                    // @ts-expect-error Need to match DialogColors with Alert's Colors
                    severity={severity}
                    action={<ActionComponent />}
                >
                    {message}
                </Alert>
            ) : undefined}
        </StyledSnackbar>
    )
}
